import { useEffect, useState } from 'react';

import { getActiveCommunityActivities } from '@/services/communitiesService';

import { showErrorToast } from '@/components/common/ToastContainer';

function useActivityFeed({ activeCommunityId, activeCommunity }) {
  const pageLimit = 20;

  const [activities, setActivities] = useState([]);
  const [loadingActivities, setLoadingActivities] = useState(false);
  const [loadingMoreActivities, setLoadingMoreActivities] =
    useState(false);
  const [activitiesFullyRendered, setActivitiesFullyRendered] =
    useState(false);

  const fetchActiveCommunityActivityData = async ({
    activityTypes = ''
  } = {}) => {
    // Reset states
    setActivities([]);
    setActivitiesFullyRendered(false);

    setLoadingActivities(true);
    const { data, error } = await getActiveCommunityActivities(
      activeCommunityId,
      { activityTypes, limit: pageLimit }
    );

    if (error) {
      showErrorToast(error);
      return;
    }

    if (data.length < pageLimit) {
      setActivitiesFullyRendered(true);
    }
    setActivities(data);
    setLoadingActivities(false);
  };

  const fetchMoreActivities = async ({
    activityTypes,
    lastActivityObjectId
  }) => {
    setLoadingMoreActivities(true);
    const { data, error } = await getActiveCommunityActivities(
      activeCommunityId,
      { activityTypes, lastActivityObjectId, limit: pageLimit }
    );

    if (error) {
      showErrorToast(error);
      return;
    }

    // Only if BE returns activities then set them
    if (data.length > 0) {
      setActivities((prev) => {
        return [...prev, ...data];
      });
    }

    // If BE returns data that are less than pageLimit sent to them, it means we've loaded all activities
    if (data.length < pageLimit) {
      setActivitiesFullyRendered(true);
    }

    setLoadingMoreActivities(false);
  };

  useEffect(() => {
    if (activeCommunity?.isManager) {
      fetchActiveCommunityActivityData();
    }
  }, [activeCommunityId]);

  return {
    fetchActiveCommunityActivityData,
    fetchMoreActivities,
    loadingActivities,
    loadingMoreActivities,
    activities,
    activitiesFullyRendered
  };
}

export default useActivityFeed;
